import { render, staticRenderFns } from "./LabSpectroscopyTube.vue?vue&type=template&id=43023e4f&"
import script from "./LabSpectroscopyTube.vue?vue&type=script&lang=ts&"
export * from "./LabSpectroscopyTube.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports